export default "__VITE_ASSET__Cz85Hg2T__"